import { useStaticQuery, graphql } from 'gatsby';


const useAllCategoriesData = () => {
  const data = useStaticQuery(graphql`
    query AllCategoryDataQuery {
      allCategory(sort: {name: ASC}) {
        nodes {
          name
          slug
          sourceId
          locale
        }
      }
    }
  `);
  const { allCategory } = data;

  return allCategory?.nodes || [];
};

export default useAllCategoriesData;
